import React from 'react';

const FieldLabelGroup: React.FC = ({ children }) => (
  <div className="field-label-group-container">
    {children}
  </div>
);

export default FieldLabelGroup;
